/* eslint-disable */ 
import React, { useState } from 'react';
import { useStateValue } from '../ContextApi/StateProvider';
import { Link, Redirect } from 'react-router-dom';
import './components.css';
import Form from './Form';

const SignIn = (props) => {
    const [emailAddress, setEmailAddress] = useState("");
    const [password, setPassword] = useState("");
    const [errors, setErrors] = useState([]);
    const [initialState, dispatch] = useStateValue();
    const authUser = initialState.authenticatedUser;

    const change = (event, setState) => {
        const value = event.target.value;
        setState(value);
    };

    const submit = async () => {
        await initialState
            .signIn(emailAddress, password)
            .then((user) => {
                if (user === null) {
                    setErrors([...errors, "Sign-In was unsuccessful."]);
                } else {
                    if (window.location.pathname === "/error") {
                        props.history.push("/home");
                    }
                    dispatch({
                        type: "SET_USER",
                        authenticatedUser: user,
                    });
                    console.log(`${emailAddress} is now signed in!`);
                }
            })
            .catch((err) => {
                console.log(err.message);
                setErrors([...errors, err.message]);
            });
    };

    const cancel = () => {
        props.history.push("/sign-up");
    };

    if (authUser) {
        return <Redirect to="/home" />;
    }

    return (
        <div className="sign-in-container">
            <div className="card-2025 p-6 sm:p-8 animate-fade">
                <div className="form-card"><Form
                    cancel={cancel}
                    submit={submit}
                    cancelButtonText="Cancel"
                    submitButtonText="Sign In"
                    elements={() => (
                        <>
                            <h2 className="form-header">
                                Sign In <i className="fas fa-sign-in-alt"></i>
                            </h2>

                            {errors.map((error, i) => (
                                <p key={i} className="sign-in-error-message">{error}</p>
                            ))}

                            <div className="form-row">
                                <label htmlFor="email" className="form-label">
                                    Email Address
                                </label>
                                <input
                                    id="email"
                                    name="emailAddress"
                                    type="email"
                                    onChange={(e) => change(e, setEmailAddress)}
                                    placeholder={emailAddress}
                                    required
                                    className="sign-in-form-input"
                                />
                            </div>

                            <div className="form-row">
                                <label htmlFor="password" className="form-label">
                                    Password
                                </label>
                                <input
                                    id="password"
                                    name="password"
                                    type="password"
                                    onChange={(e) => change(e, setPassword)}
                                    placeholder={password}
                                    required
                                    className="sign-in-form-input"
                                />
                            </div>

                            <p className="sign-in-prompt">
                                Don't have a user account?{" "}
                                <Link to="/sign-up" className="sign__link">
                                    Click here
                                </Link>{" "}
                                to sign up!
                            </p>
                        </>
                    )}
                />
            </div>
            </div>
        </div>
    );
};

export default SignIn;